export { default } from "./ServiceDeliveryTable";
